export const pushDataLayer = (payload: Record<string, unknown>) => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(payload)
}
